export default {
  methods: {
    hasPermission(resource, permission) {
      if (localStorage.getItem("user")) {
        const user = JSON.parse(localStorage.getItem("user"));
        const acl = user["acl"] || {};

        let aclResource = acl[resource] || {};

        if (aclResource[permission]) {
          return true;
        }
      }
      return false;
    },
  },
};
